module.exports = "<p>offering-analysis works!</p>\n"